module.exports = __webpack_public_path__ + "apple-icon-152x152.ef9c3852.png";